import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'app-user-registeration',
    templateUrl: './user-registeration.component.html',
    styleUrls: ['./user-registeration.component.less'],
    standalone: false
})
export class UserRegisterationComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
